import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {useAppDispatch, useAppSelector} from 'src/redux/hooks';
import {confirmSignInUser} from 'src/redux/slices/authSlice';
import {TotpCodeForm} from '../TotpCodeForm';

export const ConfirmSignInWithTotpCode = () => {
  const dispatch = useAppDispatch();
  const {isLoading} = useAppSelector(state => state.auth);
  return (
    <Stack>
      <Text size="sm" c="dimmed">
        Enter the 6-digit code from your authenticator app.
      </Text>
      <TotpCodeForm
        loading={isLoading}
        autoFocus
        onSubmit={code =>
          dispatch(confirmSignInUser({challengeResponse: code}))
        }
      />
      <Text size="sm" c="dimmed">
        Lost your authenticator? Contact support to recover your account.
      </Text>
    </Stack>
  );
};
